<template>
    <div class="terms">
        <div class="terms__container">
            <div class="terms__terms">
                <p v-html="data.intro"></p>
                <ul>
                    <li v-for="(item, i) in data.terms" v-html="item.text" :key="i"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Content from '../data/content.js'
let lang = process.env.VUE_APP_LOCALITY;

export default {
  data: function() {
    return {
      data: Content[lang].tandcs,
    }
  },
};
</script>

<style>
.terms__container {
    width: calc(100vh - 60px);
    max-width: 1022px;
    background: #ffffff;
    margin: -99px auto 80px;
    border-radius: 30px;
    padding: 58px 104px 35px;
    counter-reset: Chapter-counter;
    border-radius: 30px;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.03), 0px 3px 1px -2px rgba(0, 0, 0, 0.07), 0px 1px 5px 0px rgba(0, 0, 0, 0.06);
}

.terms p, li {
    color: #242E30;
    font-family: "JET Sans Digital";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
    letter-spacing: -0.14px;
}

.terms li {
    margin-bottom: 16px;
}

.terms a {
    color: #ff8000;
}


@media only screen and (max-width: 992px) { 
    .terms__container {
        max-width: calc(100% - 60px);
        border-radius: 15px;
        padding: 40px 15px;
    }

    .terms p, .terms li {
        font-size: 14px;
    }
}
@media only screen and (max-width: 1200px) and (min-width: 992px) {
}
</style>